<ng-template #template>
    <div class="modal-header">
        <h5 class="modal-title">Fermi tecnici - {{vehicle.plate}} </h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="modalRef.hide()">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>

    <div class="modal-body">

        <tabset type="pills">

          <tab heading="Programmati">
            <li class="list-group-item d-flex justify-content-between align-items-center"
                *ngFor="let technicalShutdown of dom_elements.technical_shutdowns">
              <div style="width: 100%;">
                <div style="width: 100%;  display: flex; flex-wrap: wrap;">
                  <div class="col-12">
                    <b>
                      {{dateHandler.formatDateClassic(technicalShutdown._from)}} :
                      {{dateHandler.formatTimeClassic(technicalShutdown._from)}}
                      -
                      {{technicalShutdown.to ?
                        dateHandler.formatDateClassic(technicalShutdown.to) + ' : ' +
                        dateHandler.formatTimeClassic(technicalShutdown.to) :
                        'Indefinito' }}
                    </b>
                  </div>
                  <div class="col-12">
                    <label for="motivazione">Motivazione - Luogo</label>
                    <textarea class="form-control height250"  id="motivazione" disabled
                              [(ngModel)]="technicalShutdown.motivation"></textarea>
                  </div>
                  <div class="col-6"></div>
                  <div class="col-3">
                        <span class="badge badge-info badge-pill cursor-click" style="margin:3em;"
                              (click)="edit(technicalShutdown)">
                            <i class="fa fa-edit"
                               style="margin-right:2px;"></i> Modifica
                        </span>
                  </div>
                  <div class="col-3">
                        <span class="badge badge-primary badge-pill cursor-click" style="margin:3em;"
                              (click)="delete(technicalShutdown)">
                            <i class="fa fa-stop"
                               style="margin-right:2px;"></i> Cancella
                        </span>
                  </div>
                </div>
              </div>
            </li>
            <li class="list-group-item d-flex justify-content-between align-items-center"
                *ngIf="dom_elements.technical_shutdowns.length === 0">
              <div style="width: 100%;">
                <div style="width: 100%;  display: flex; flex-wrap: wrap;">
                  <div class="col-12">
                    <b>Nessun fermo tecnico programmato </b>
                  </div>
                </div>
              </div>
            </li>

          </tab>

          <tab heading="Storico">

            <li class="list-group-item d-flex justify-content-between align-items-center"
                *ngFor="let fermotecnico of listaStoricoFermoTecnico">
              <div style="width: 100%;">
                <div style="width: 100%;  display: flex; flex-wrap: wrap;">
                  <div class="col-12">
                    <b>
                      {{dateHandler.formatDateClassic(fermotecnico._from)}} :
                      {{dateHandler.formatTimeClassic(fermotecnico._from)}}
                      -
                      {{fermotecnico.to ?
                        dateHandler.formatDateClassic(fermotecnico.to) + ' : ' +
                        dateHandler.formatTimeClassic(fermotecnico.to) :
                        'Indefinito' }}
                      -
                    </b>
                    <small
                      *ngIf="fermotecnico.closed_at">Chiuso il
                      {{
                        dateHandler.formatDateClassic(fermotecnico.closed_at) + ' : ' +
                        dateHandler.formatTimeClassic(fermotecnico.closed_at)
                      }}
                    </small>

                  </div>
                  <div class="col-12">
                    <label for="motivazione">Motivazione - Luogo</label>
                    <textarea class="form-control height250"  id="motivazione" disabled
                              [(ngModel)]="fermotecnico.motivation"></textarea>
                  </div>
                </div>
              </div>
            </li>

          </tab>

        </tabset>





    </div>

    <div classs="modal-footer">

        <button type="button" class="btn btn-outline-success" style="margin:1em;"
                (click)="createFermo()">
            <i class="fa fa-plus"></i> Aggiungi fermo
        </button>

    </div>
</ng-template>
